import fixWebmDuration from 'fix-webm-duration';

/** MediaRecorder WebM blobs often lack duration metadata; patch using elapsed ms. */
export function patchRecordedWebmDuration(blob: Blob, durationMs: number): Promise<Blob> {
  if (!blob.size || durationMs <= 0) {
    return Promise.resolve(blob);
  }

  const type = blob.type || 'video/webm';
  if (!type.includes('webm')) {
    return Promise.resolve(blob);
  }

  return fixWebmDuration(blob, durationMs, { logger: false }).then((fixedBlob) =>
    fixedBlob?.size ? fixedBlob : blob
  );
}
